import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from '../../actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
const {
  GET_DASHBOARD_TIME_IN_REQUEST,
  GET_DASHBOARD_TIME_IN_SUCCESS,
  GET_DASHBOARD_TIME_IN_FAILURE,
  GET_DASHBOARD_TIME_IN_LOADER,
} = DashboardConstants;

function* dashboardTimeCheckIn(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_TIME_IN_LOADER });
    const response = yield call(dashboardServices.getTimeCheckIn, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_TIME_IN_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_TIME_IN_FAILURE, payload: error });
  }
}

function* dashboardTimeCheckInSaga() {
  yield takeEvery(GET_DASHBOARD_TIME_IN_REQUEST, dashboardTimeCheckIn);
}

export default dashboardTimeCheckInSaga;
